import React from 'react';
import {API_URL} from '../index';
import Dialog from '@material-ui/core/Dialog';
import { useState, useRef, useEffect } from 'react';
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {Grid, Paper, Divider} from '@material-ui/core'
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Container from '@material-ui/core/Container';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Select from 'react-select';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';
import Docs from './Docs';
import DeleteDialog from './DeleteDialog';


const useStyles = makeStyles(theme => ({

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: 150,
  },

}));

export default function Doc(props) {
  const classes = useStyles();

  const [fetching, setFetching] = useState(false);
  const [title, setTitle] = useState();
  const [years, setYears] = useState();
  const [placement, setPlacement] = useState();
  const [archive, setArchive] = useState();
  const [archive_key, setArchiveKey] = useState();
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState();
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [checked, setChecked] = useState();
  const [message, setMessage] = useState();
  const [archives, setArchives] = useState();
  const [response, setResponse] = useState();
  const [access, setAccess] = useState();

  const titleRef = useRef();
  const yearsRef = useRef();
  const placementRef = useRef();
  const archiveRef = useRef();

  const getDocFields = () => {
      setTitle(titleRef.current.value);
      setYears(yearsRef.current.value);
      setPlacement(placementRef.current.value);
  };

  const handleClose = value => {
      setOpen(false);
      props.update_doclist();
  };

  const handleOpen = value => {
      setResponse(undefined)
      setTitle(props.doc.title);
      setYears(props.doc.years);
      setPlacement(props.doc.placement);
      setArchive(props.doc.archive_ls != null ? {value: props.doc.archive_ls.id,
                                                 label: props.doc.archive_ls.title_short} : null);
      setChecked(props.doc.archive_ls != null ? true : false)
      setOpen(true);
      console.log(placement)
  };

  useEffect(() => {
    isAccess();
    const archives_url = API_URL + 'archives/'

    fetch(archives_url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(data => data.results.map(archive => ({
                      value: archive.id,
                      label: archive.title_short,
                    })))
      .then(data => setArchives(data))
  }, []);


  const handleChecked = () => {
    if (checked) {
      setChecked(false);
      setArchive(null);
    } else {
      setChecked(true);
      setArchive({value: props.archive.id,
                label: props.archive.title_short})
    }
  }

  const handleChangeArchiveLS = archive => {
      setArchive(archive);
    }

  const SaveDoc = () => {
    setFetching(true)
    const docs_url = API_URL + 'doc_edit/' + props.doc.id + '/'
    const doc = {
            "title": title,
            "years": years,
            "placement": placement ? placement : null,
            "archive_ls": checked ? archive.value : null,
            "user": props.user.pk,
            "archive_key": props.archive.id
          }
      fetch(docs_url, {
        method: 'PATCH',
        body: JSON.stringify(doc),
        headers: { 'Authorization': 'Token ' + (token), 'Content-Type': 'application/json' }
      })
      .then(response => 
        (response.status == 400 ?
          response.json().then(data =>
            setResponse(data))
            .then(e => console.log(response)) :
          response.json().then(data =>
            setResponse(data))
          .then(e => handleClose())
          .then(e => console.log(response))
          )
        )
  }

  const isAccess = () => {
    props.archive != undefined && props.doc != undefined ?
      (props.archive.id === props.doc.archive_key.id || props.archive.id === (props.organisation.archive_spec != null ? props.organisation.archive_spec.id : 0) ?
       setAccess(true) :
       setAccess(false)) :
    setAccess(false)
  }

  const MetaInfo = () => {
    return(<React.Fragment>
              <br/>
              <Grid container style={{color: '#bbbbbb'}}>
              <Grid xs={2}>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                Пользователь:
              </Typography>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                Архив:
              </Typography>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                Дата:
              </Typography>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                Последнее обновление:
              </Typography>
              <Divider orientation='horizontal' />
              </Grid>
              <Grid xs={5}>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                {props.doc.user.username}
              </Typography>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                {props.doc.archive_key.title_short}
              </Typography>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                {props.doc.date ? props.doc.date.slice(0, 10) : null}
              </Typography>
              <Divider orientation='horizontal' />
              <Typography variant="caption" display="block" gutterBottom>
                {props.doc.up_date ? props.doc.up_date.slice(0, 10) : null}
              </Typography>
              <Divider orientation='horizontal' />
              </Grid>
              <Grid xs={1}>
              <br/>
                <DeleteDialog document={props.doc} close={handleClose}/>
              </Grid>
              </Grid>
          </React.Fragment>
      )
  }

  return (
    <React.Fragment>
    <Tooltip title='Редактировать' placement='right-end' style={{float: 'right'}}>
      <IconButton size="small" onClick={handleOpen} disabled={access ? false : true}>
        <EditIcon color={access ? 'primary' : 'default'}/>
      </IconButton>
    </Tooltip>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth maxWidth='md'>
      <DialogTitle id="simple-dialog-title">{props.doc.id}
      <Tooltip title='Закрыть' placement='left-end' style={{float: 'right'}}>
        <IconButton onClick={handleClose}>
          <CloseIcon/>
        </IconButton>
      </Tooltip>
      </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <form noValidate autoComplete="off">
          <TextField
            multiline
            required
            margin="dense"
            id="title"
            label="Вид документов"
            value={title}
            fullWidth
            inputRef={titleRef}
            onChange={getDocFields}
            error={response ? response.title : false}
            helperText={response ? response.title : false}
          />
          <TextField
            multiline
            required
            margin="dense"
            id="years"
            label="Крайние даты"
            value={years}
            fullWidth
            inputRef={yearsRef}
            onChange={getDocFields}
            error={response ? response.years : false}
            helperText={response ? response.years : false}
          />
          <TextField
            required
            multiline
            margin="dense"
            id="placement"
            label="Местонахождение"
            value={placement}
            fullWidth
            inputRef={placementRef}
            onChange={getDocFields}
            error={response ? response.placement : false}
            helperText={response ? response.placement : false}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleChecked}
                value="checked"
                color="secondary"
              />
            }
            label="Указать архив в качестве места нахождения документов"
          />
          {checked ?
            <Select
              native
              value={archive}
              onChange={handleChangeArchiveLS}
              options={archives}
              placeholder="Архив"
            />
          :
          <div><br/></div>}
          </form>
          </DialogContentText>

          <MetaInfo />
        </DialogContent>
         {token != undefined ?
        <DialogActions>
          <Button color="primary" onClick={SaveDoc}>
            Сохранить
          </Button>
          <Button color="secondary" onClick={handleClose}>
            Отмена
          </Button>
        </DialogActions>
        :
        <div></div>}
      </Dialog>
    </React.Fragment>
  );
}